export default __webpack_public_path__ + "static/media/gallery2.fde231c9.jpg";